import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert";
import { Country, State } from "country-state-city";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MultiselectorComp from "../../MultiselectorComp/MultiselectorComp";
import api from "../dependencies/utils/Api";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import { ALL_STARTUP_SEARCH_REQUEST_SUBMIT } from "../../common/constants/ApplicationUrl";
import { getPredefineOptionsList } from "../../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    minHeight: "45px",
    color: "#333",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};
//Steps to use this component for data:
//1.Create a state variable and send the values are props to this component
//2.set the state here using props.
//3.inside the useEffect of parent , after the setState event occurs value will be reflected

//Steps to hide this Component
//1.create a set variable , use this to toggle visibility.
//2.send both the normal and setValue.
const ModalFilters = (props) => {
  const newCountryArray = [];
  const newStateArray = [];
  const defaultFormData2 = {
    search: "",
    industry: "",
    subindustry: [],
    specialization: "",
    subspecialization: [],
    stage: "",
    recognized: "",
    state: "",
    state_name: "",
    country: "",
  };

  const [errorMsg, setError] = useState(false);
  const [filterData, setFilterData] = useState();
  const [filterData2, setFilterData2] = useState([]);
  const [filterData3, setFilterData3] = useState();
  const [filterData4, setFilterData4] = useState([]);
  const [filterData5, setFilterData5] = useState();
  const [filterData6, setFilterData6] = useState();
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState("");
  const [formData, setFormData] = useState(defaultFormData2);
  const { registerMentor, getPredefineOptionsList, getPredefineOptions } =
    props;
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  useEffect(() => {
    const dropdownList =
      getPredefineOptions && getPredefineOptions.industry_options.shift();
    const dropdownList2 =
      getPredefineOptions && getPredefineOptions.functional_areas.shift();
    const dropdownList4 =
      getPredefineOptions && getPredefineOptions.sub_industry.shift();
    const dropdownList5 =
      getPredefineOptions && getPredefineOptions._specialisation.shift();
  }, [getPredefineOptions]);
  const handleFilterChanges = () => {
    const newsubArray = [];
    const newsubSpecialArray = [];
    let value = localStorage.getItem("SavedLoggedInData");
    let LoginData = JSON.parse(value);
    formData?.subindustry.map((stage) => {
      newsubArray.push(stage.value);
    });
    formData?.subspecialization.map((stage) => {
      newsubSpecialArray.push(stage.value);
    });
    if (
      filterData &&
      filterData?.length > 0 &&
      filterData3 &&
      filterData3?.length > 0 &&
      filterData6
    ) {
      if (
        newsubSpecialArray.length === 10 ||
        newsubArray.length === 10 ||
        (newsubSpecialArray.length > 0 && newsubArray.length > 0)
      ) {
        let output = {
          industry: filterData,
          function: filterData3,
          sub_industry: newsubArray,
          sub_function: newsubSpecialArray,
          stage: filterData5,
          state: filterData6,
          requestedBy: LoginData.id,
        };
        api.POST(ALL_STARTUP_SEARCH_REQUEST_SUBMIT, output).then((response) => {
          const { status, data } = response;
          if (status === 200) {
            swal({
              title: "Success",
              text: `Request Submitted Successfully`,
              icon: "success",
              timer: 2500,
              buttons: false,
            });
            props.sendToParent(response);
            props.setModalVisibility(false);
          } else {
            return Promise.reject(response.data);
          }
        });
      } else {
        let output = {
          industry: filterData,
          function: filterData3,
          sub_industry: newsubArray,
          sub_function: newsubSpecialArray,
          stage: filterData5,
          state: filterData6,
          requestedBy: LoginData.id,
        };
        // setError(true);
        // swal({
        //   title: "Error",
        //   text: "All fields are mandatory!",
        //   icon: "warning",
        //   timer: 2500,
        //   buttons: false,
        // });
      }
    } else {
      let output = {
        industry: filterData,
        function: filterData3,
        sub_industry: newsubArray,
        sub_function: newsubSpecialArray,
        stage: filterData5,
        state: filterData6,
        requestedBy: LoginData.id,
      };
      setError(true);
      // 
      // swal({
      //   title: "Error",
      //   text: "All fields are mandatory!",
      //   icon: "warning",
      //   timer: 2500,
      //   buttons: false,
      // });
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={props.modalVisibility}
        onHide={() => props.setModalVisibility(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ borderRadius: "7px" }}
      >
        <Modal.Header className="d-flex justify-content-center" closeButton>
          <Modal.Title className="modalHeading">
            MENTORSHIP REQUIREMENT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center">
            <div
              className="d-flex mt-2 startupstepsforms"
              style={{ maxWidth: "33rem", flexDirection: "column" }}
            >
              <h6 className="mt-2">Industry (Select 1 Industry) *</h6>
              <MultiselectorComp
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Select Industry"
                options={
                  getPredefineOptions && getPredefineOptions.industry_options
                }
                onChange={(e) => {
                  setFilterData(e.value);
                }}
                closeMenuOnSelect={true}
              />
              <h6 className="mt-2">
                Industry / Sector - Keywords (Industry/Function Keywords select
                up to 10) *{" "}
              </h6>
              <MultiselectorComp
                options={
                  getPredefineOptions && getPredefineOptions.sub_industry
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Industry/Sector Keywords"
                onChange={(list) =>
                  list.length <= 10 - formData.subspecialization.length
                    ? setFormData((user) => {
                        let arr = list.filter(function (item) {
                          return item.value !== "select";
                        });
                        let newArr = [];
                        arr.forEach((item) => {
                          newArr.push(item.value);
                        });

                        setFilterData2(newArr);
                        return { ...user, subindustry: arr };
                      })
                    : null
                }
                value={formData.subindustry}
              />
              <h6 className="mt-2">Function (Select 1 Function) *</h6>
              <MultiselectorComp
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                placeholder="Select Function"
                styles={customStyles}
                options={
                  getPredefineOptions && getPredefineOptions.functional_areas
                }
                onChange={(e) => {
                  setFilterData3(e.value);
                }}
              />
              <h6 className="mt-2">
                Function - Keywords (Industry/Function Keywords select up to 10)
                *
              </h6>
              <MultiselectorComp
                options={
                  getPredefineOptions && getPredefineOptions._specialisation
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                placeholder="Function Keywords"
                styles={customStyles}
                onChange={(list) =>
                  list.length <= 10 - formData.subindustry.length
                    ? setFormData((user) => {
                        let arr = list.filter(function (item) {
                          return item.value !== "select";
                        });

                        let newArr = [];
                        arr.forEach((item) => {
                          newArr.push(item.value);
                        });
                        setFilterData4(newArr);
                        return { ...user, subspecialization: arr };
                      })
                    : null
                }
                value={formData.subspecialization}
              />
              <h6 className="mt-2">
                Current Stage of the Startup (Select 1 Stage) *
              </h6>
              <MultiselectorComp
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Select Stage"
                options={
                  getPredefineOptions &&
                  getPredefineOptions.stage_of_startup_options
                }
                onChange={(e) => {
                  setFilterData5(e.value);
                }}
                closeMenuOnSelect={true}
              />
              {errorMsg && (
                <div className="login-error-msg mt-2">
                  Please select at least one mandatory filter
                </div>
              )}
              <div className="lastFilter">
                <h6 className="mt-2">State</h6>
                <Select
                  required={true}
                  id="state"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="State"
                  name="state"
                  className="col-12 "
                  styles={customStyles}
                  onChange={(e) => {
                    setFilterData6(e.label);
                  }}
                  options={newStateOptions}
                  placeholder="State*"
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            onClick={handleFilterChanges}
            text="Submit"
            className="modalButton"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {
  getPredefineOptionsList,
})(withRouter(ModalFilters));
